<template>
  <div class="page blog-page">
    <section class="blog-placeholder card">
      <h1>SRFulfill Blog</h1>
      <p>Insights for POD sourcing, customization, fulfillment, and ecommerce growth are coming soon.</p>
      <router-link class="primary-button" to="/contact_us">Talk to Our Team <span>&gt;</span></router-link>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Blog'
};
</script>
